import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import type { OperateTabId } from '../workspace/projectPhases';

/** Legacy Operate tab aliases (`/testing`, etc.) that must keep ?request= / ?incident=. */
export const OperateTabAliasRedirect: React.FC<{ tab: OperateTabId }> = ({ tab }) => {
  const { projectId = '' } = useParams();
  const location = useLocation();
  return <Navigate to={`/projects/${projectId}/operate/${tab}${location.search}`} replace />;
};

export default OperateTabAliasRedirect;
